export default __webpack_public_path__ + "static/media/UCF.40940abf.jpeg";